import { isBrandRefreshEnabled } from '../../shared/utilities/brandRefresh';

/** Brand-refresh checkout UI only when REACT_APP_BRAND_REFRESH_ENABLED === 'true'. */
export const isReviewOrderBrandRefresh = () => isBrandRefreshEnabled();

/** data-region value only when brand refresh is on — keeps legacy DOM attrs unchanged. */
export const getCheckoutRegionProps = () =>
  isBrandRefreshEnabled() ? 'checkout' : undefined;

/** data-part value only when brand refresh is on — keeps legacy DOM attrs unchanged. */
export const getCheckoutPartProps = part =>
  isBrandRefreshEnabled() ? part : undefined;

/** Back / Edit Cart icon — brand-refresh SVG when flag on, else legacy. */
export const getCheckoutBackIcon = (legacyIcon, brandRefreshIcon) =>
  isBrandRefreshEnabled() ? brandRefreshIcon : legacyIcon;

/** Checked checkbox glyph for brand-refresh checkout only. */
const brandRefreshCheckedIcon = require('./imgs/brand-refresh-checked.svg');

/** Collapsed-section alert glyph for brand-refresh checkout only. */
const brandRefreshAlertIcon = require('../../components/CheckOutContainer/imgs/brand-refresh-alert-icon.svg');

/**
 * CheckBox checkIconSrc for checkout brand refresh.
 * Returns undefined when flag is off so CheckBox keeps its default icon.
 */
export const getCheckoutCheckIconSrc = () =>
  isBrandRefreshEnabled() ? brandRefreshCheckedIcon : undefined;

/**
 * Header alert icon for checkout sections (CheckoutContainer, expanders).
 * Legacy uses alert-icon.svg; brand refresh uses brand-refresh-alert-icon.svg.
 */
export const getCheckoutAlertIconSrc = legacyAlertIcon =>
  isBrandRefreshEnabled() ? brandRefreshAlertIcon : legacyAlertIcon;

/**
 * Order Summary product label — Figma: "1 · Chocolate Chunk".
 * Legacy keeps "1 Chocolate Chunk".
 */
export const getOrderItemLabel = (quantity, title) =>
  isBrandRefreshEnabled() ? `${quantity} · ${title}` : `${quantity} ${title}`;

/**
 * Product line total for Order Summary.
 * Brand refresh: full line value (base + options) × quantity.
 * Legacy: subtracts option line charges from the multiplied total (existing behavior).
 */
export const getOrderItemLineAmount = ({
  unitTotal,
  quantity,
  productOptionsPrice,
  isRedeemable,
  redeemablePrice,
}) => {
  if (isRedeemable) {
    return redeemablePrice;
  }
  const full = parseFloat((unitTotal * quantity).toFixed(2));
  if (isBrandRefreshEnabled()) {
    return full;
  }
  return parseFloat((full - productOptionsPrice).toFixed(2));
};
